import { Input, Modal } from "antd"
import { useEffect, useState } from "react"

type Props = {
  isOpen: boolean
  onCancel: () => void
  onCopy: (newTemplateName: string) => void
  templateCopyName: string
}

const CopyTemplateModal = ({ isOpen, onCancel, templateCopyName, onCopy }: Props) => {
  const [name, setName] = useState(templateCopyName)

  /* eslint-disable-next-line */
  useEffect(() => setName(templateCopyName), [isOpen])

  return <Modal
    open={isOpen}
    title="Copy Template"
    onCancel={onCancel}
    okText='Create Copy'
    onOk={() => onCopy(name)}
  >
    <Input value={name} onChange={e => setName(e.target.value)} maxLength={150} />
  </Modal>
}

export default CopyTemplateModal
